import React, { Component } from 'react';
import { CaseStudies } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class CaseStudiesVisualExpiriencesView extends Component {

	render () {
		const {
			cases,
			heading,
		} = this.props.content.landingPage.caseStudiesVisualExpiriences;

		return (
			<CaseStudies
				{...{
					cases,
					heading,
				}}
			/>
		);
	}

}

export default withLanguageContext(CaseStudiesVisualExpiriencesView);



// WEBPACK FOOTER //
// ./src/components/views/CaseStudiesVisualExpiriencesView/CaseStudiesVisualExpiriencesView.js